import { Button } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import PropTypes from "prop-types";

export default function ExpandButton({
  onClick,
  children,
  expanded,
  iconPosition = "start",
  ...buttonProps
}) {
  const position = {
    [iconPosition === "start" ? "startIcon" : "endIcon"]: expanded ? (
      <KeyboardArrowUpIcon />
    ) : (
      <KeyboardArrowDownIcon />
    ),
  };

  return (
    <Button {...buttonProps} onClick={onClick} {...position}>
      {children}
    </Button>
  );
}

ExpandButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  expanded: PropTypes.bool,
  iconPosition: PropTypes.oneOf(["start", "end"]),
  onClick: PropTypes.func,
  variant: PropTypes.string,
};
